import type { Editor } from "@tiptap/react";
import { NodeSelection } from "@tiptap/pm/state";

/**
 * Writes a block node into the document at the caret, after whatever the caret rests on.
 *
 * `insertContent` replaces the selection, and a fresh editor's selection is the first thing in
 * the document — which, when the document opens with an atom such as a picture or a video, is
 * that node itself rather than a place in the text. Inserting into such a selection swapped the
 * first block for the new one. A node selection therefore inserts at its end, so the new block
 * follows the selected one; a text selection inserts as before.
 *
 * @param editor - The editor to write into.
 * @param content - The block node, as `{ type, attrs }`.
 */
export function insertBlock(
	editor: Editor,
	content: { type: string; attrs?: Record<string, unknown> },
) {
	const { selection } = editor.state;
	const chain = editor.chain().focus();
	if (selection instanceof NodeSelection) {
		chain.insertContentAt(selection.to, content).run();
		return;
	}
	chain.insertContent(content).run();
}
